import { Href, Redirect } from "expo-router";
import { PENDING_SIGNOFFS_TABS } from "app/constants/tabConstants";

export default function PendingSignOffsPage() {
  return <Redirect href={PENDING_SIGNOFFS_TABS[0]!.path as Href} />;
}
